<template>
 <b-modal v-model="showModal" hide-footer title="Select your company to begin" no-close-on-backdrop no-close-on-esc hide-header-close>
    <div class="px-5 pb-5">
      <div class="text-center my-5">
        <span class="fa-stack fa-3x">
          <i class="fas fa-circle fa-stack-2x icon-gradient"></i>
          <i class="fas fa-check fa-stack-1x fa-inverse"></i>
        </span>
      </div>
      <b-form-group class="mb-1">
        <b-form-select :options="companiesOptions" v-model="selectedCompanyId" size="lg"></b-form-select>
      </b-form-group>
      <b-row>
        <b-col class="d-flex justify-content-center">
          <b-button variant="primary" size="lg" @click="handleCompanySelected" class="w-100">Apply</b-button>
        </b-col>
      </b-row>
    </div>
  </b-modal>

</template>
<script>
export default {
  data: function () {
    return {
      selectedCompanyId: this.$store.state.userCurrentCompany.companyId,
      showModal: true
    }
  },
  computed: {
    companies () {
      return this.$store.state.userCompanies
    },
    companiesOptions () {
      var project = (o, p) => {
        return { text: o.companyName, value: o.companyId }
      }

      var results = []

      for (var i = 0; i < this.companies.length; i++) {
        var obj = this.companies[i]
        var projection = { text: 1, value: 1 }
        var projectedObj = project(obj, projection)
        console.log(projectedObj)
        results.push(projectedObj)
      }
      console.log('Returning Property Options: ' + JSON.stringify(results, null, 2))
      return results
    }
  },
  methods: {
    async handleCompanySelected () {
      this.$store.commit('setUserCurrentCompanyById', this.selectedCompanyId)
      await this.$auth.refreshCompanyPermissionsForUser()
      await this.$store.dispatch('featureFlags/fetchFlags', { companyId: this.selectedCompanyId })
      this.$router.push({name: 'EntryPoint'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/PickCompanyOfInterest.vue